export default __webpack_public_path__ + "static/media/zw.bf3ca7ab.svg";